module.exports = {
      id: "spotify-color-icon-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#spotify-color-icon",
      toString: function () {
        return this.url;
      }
    }